<template>
  <form>
    <div v-if="canBack" class="d-flex justify-content-end">
      <back-button @click="$emit('back')" />
    </div>
    <div class="card card-container position-relative rounded-3 shadow my-3" :class="wide ? 'mx-2 p-4' : 'mx-5 p-5'">
      <div class="card-body p-0">
        <slot />
      </div>
      <div class="d-flex justify-content-center gap-3">
        <slot name="submit-button" />
      </div>
      <slot name="content" />
    </div>
    <div class="d-flex justify-content-between" :class="wide ? 'mx-2' : 'mx-5'">
      <div class="d-flex gap-3">
        <slot name="expansion-buttons-left" />
      </div>
      <div class="d-flex gap-3">
        <slot name="expansion-buttons-center" />
      </div>
      <div class="d-flex gap-3">
        <slot name="expansion-buttons-right" />
      </div>
    </div>
  </form>
</template>

<script>
import BackButton from '@/views/molecules/buttons/BackButton';

export default {
  name: "BaseForm",
  emits: ['back'],
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    BackButton,
  },
}
</script>
